export const DEFAULT_PRIMARY_COLOR = '#011E1E';
export const DEFAULT_SECONDARY_COLOR = '#B8EF36';
